import parse from 'utils/parse';

const makeTestId = (...ids: string[]): string => parse.toTestId('landing', 'online-support', ...ids);

const testId = Object.freeze({
  component: makeTestId(),
  toggleIcon: makeTestId('toggle-icon'),
  chatContainer: makeTestId('chat-container'),
  minimizedChat: makeTestId('minimized-chat'),
  minimizeButton: makeTestId('minimize-button'),
  maximizeButton: makeTestId('maximize-button'),
});

const bottomPageScrollOffset = 30;

export { testId, bottomPageScrollOffset };
